import { Row, Col, Panel, Content, Navbar, DateRangePicker, IconButton, Pagination, Table } from "rsuite"
import SettingIcon from '@rsuite/icons/Setting';
import { useEffect, useState } from "react";
import { formatTimestamp } from '../../utils/formatTimestamp';

import ActionCell from "../tables/actionCell";
import StatusCell from "../tables/statusCell";
import BriefCreateDrawer from "./briefCreateDrawer";

const getBriefs = (manager_id, setBriefs, setLoading) => {
    fetch(`${process.env.REACT_APP_API_HOST}/api/briefs/?` + new URLSearchParams({
            manager_id
        }).toString(), {
            method: 'GET'
      }).then((res) => {
        res.json().then((data) => {
            setBriefs(data);
            setLoading(false);
        });
      });
    };

export default function BriefList({open, setOpen}) {
    const [briefs, setBriefs] = useState([]);

    const { Column, HeaderCell, Cell } = Table;

    const [limit, setLimit] = useState(30);
    const [page, setPage] = useState(1);
    const [tableLength, setTableLength] = useState(0);

    const [loading, setLoading] = useState(true);
    const [sortedBy, setSortedBy] = useState("name");
    const [sortedDir, setSortedDir] = useState();

    function onSortChange(sortColumn, sortType) {
        setSortedBy(sortColumn);
        setSortedDir(sortType);
    }

    const handleChangeLimit = dataKey => {
        setPage(1);
        setLimit(dataKey);
    };

    useEffect(() => {
        getBriefs(2, setBriefs, setLoading)
    }, []);

    return (
        <div style={{ height: "100%" }}>
            <div style={{ height: "calc(100% - 5rem)" }}>
                <Table sortColumn={sortedBy} sortType={sortedDir} loading={loading} onSortColumn={(sortColumn, sortType) => {
                    onSortChange(sortColumn, sortType)
                }} fillHeight data={briefs}>
                    <Column align="center" sortable={true} flexGrow={2} fixed>
                        <HeaderCell>Название</HeaderCell>
                        <Cell dataKey="name"></Cell>
                    </Column>
                    <Column align="center" sortable={true} flexGrow={2} fixed>
                        <HeaderCell>Проект</HeaderCell>
                        <Cell dataKey="project_name"></Cell>
                    </Column>
                    <Column align="center" sortable={true} flexGrow={2} fixed>
                        <HeaderCell>Компания</HeaderCell>
                        <Cell dataKey="company_name"></Cell>
                    </Column>
                    <Column align="center" sortable={true} flexGrow={2} fixed>
                        <HeaderCell>Статус</HeaderCell>
                        <StatusCell dataKey="status"></StatusCell>
                    </Column>
                    <Column align="center" sortable={true} flexGrow={2} fixed>
                        <HeaderCell>Последняя отправка</HeaderCell>
                        <Cell dataKey="last_submitted_at">{rowData => {
                            if (!rowData.last_submitted_at) return '—';
                            return formatTimestamp(rowData.last_submitted_at);
                        }}</Cell>
                    </Column>
                    <Column align="center" flexGrow={1} fixed>
                        <HeaderCell></HeaderCell>
                        <ActionCell open={open} setOpen={setOpen} updateBriefs={() => getBriefs(2, setBriefs, setLoading)}></ActionCell>
                    </Column>
                </Table>
            </div>
            <div style={{ padding: 20 }}>
                <Pagination
                    prev
                    next
                    first
                    last
                    ellipsis
                    boundaryLinks
                    maxButtons={5}
                    size="xs"
                    layout={['total', '-', 'limit', '|', 'pager', 'skip']}
                    total={tableLength}
                    limitOptions={[10, 30, 50]}
                    limit={limit}
                    activePage={page}
                    onChangePage={setPage}
                    onChangeLimit={handleChangeLimit}
                />
            </div>
            <BriefCreateDrawer open={open} setOpen={setOpen} updateBriefs={() => getBriefs(2, setBriefs, setLoading)}/>
        </div>
    )
}